import type { ICareProviderContactDraft } from '../../../common/validation/careProviderContact';
import type { ICustomControlRequestAddEditProps } from '../pages/customControls/interfaces/';
import { translateKey } from '../../translate';
import { InputTextArea } from './common';
import { FormLabel } from './forms/FormLabel';
import { HorizontalFormGroup } from './forms/HorizontalFormGroup';
import { InputContainer } from './forms/InputContainer';

export function CareProviderContactAddEdit(props: ICustomControlRequestAddEditProps) {
    const contactData = props.request.customControlData.contactgegevens_specialist;

    return (
        <>
            <HorizontalFormGroup
                hasErrors={props.errors.has('customControlData.contactgegevens_specialist.phoneNumber')}
            >
                <FormLabel isRequired>{translateKey('common.phoneNumber')}</FormLabel>
                <InputContainer size="auto">
                    <InputTextArea
                        automation="phoneNumber"
                        error={props.errors.get('customControlData.contactgegevens_specialist.phoneNumber')}
                        onChange={async (value) => await handleChange('phoneNumber', value)}
                        onDoValidate={async () =>
                            await props.validateOneCustomControl('contactgegevens_specialist.phoneNumber')
                        }
                        placeholder={translateKey('common.phoneNumber')}
                        value={contactData.phoneNumber}
                    />
                </InputContainer>
            </HorizontalFormGroup>
            <HorizontalFormGroup
                hasErrors={props.errors.has('customControlData.contactgegevens_specialist.emailAddress')}
            >
                <FormLabel isRequired>E-mailadres voor afstemmen contact</FormLabel>
                <InputContainer>
                    <InputTextArea
                        automation="emailAddress"
                        error={props.errors.get('customControlData.contactgegevens_specialist.emailAddress')}
                        onChange={async (value) => await handleChange('emailAddress', value)}
                        onDoValidate={async () =>
                            await props.validateOneCustomControl('contactgegevens_specialist.emailAddress')
                        }
                        placeholder="E-mailadres voor afstemmen contact"
                        value={contactData.emailAddress}
                    />
                </InputContainer>
            </HorizontalFormGroup>
        </>
    );

    async function handleChange<K extends keyof ICareProviderContactDraft>(
        name: K,
        value: ICareProviderContactDraft[K]
    ) {
        await props.handleChangeCustomControl({
            contactgegevens_specialist: {
                ...props.request.customControlData.contactgegevens_specialist,
                [name]: value,
            },
        });
    }
}
